export const volumes = [
  {
    title: 'Volumen 1 — Mapa de la Historia Médica™',
    border: 'border-blue-400/30',
    items: [
      'Ordenás 10 años de papeles en una estructura clara',
      'Creás una línea de tiempo fácil de presentar',
      'Organizás estudios de forma accesible',
      'Tenés un resumen de antecedentes listo'
    ]
  },
  {
    title: 'Volumen 2 — Registro Inteligente de Crisis™',
    border: 'border-green-400/30',
    items: [
      'Documentás lo que observás de forma ordenada',
      'Anotás contexto y observaciones sin interpretar',
      'Creás un registro visual que el médico revisa rápidamente',
      'Organizás los datos para que el profesional los evalúe'
    ]
  },
  {
    title: 'Volumen 3 — Preguntas Que Importan™',
    border: 'border-amber-400/30',
    items: [
      'Organizás tus dudas por orden de importancia',
      'Entrás preparada, sin bloquearte por los nervios',
      'El médico recibe tus preguntas de forma clara',
      'Salís con las respuestas documentadas'
    ]
  },
  {
    title: 'Volumen 4 — La Consulta en Orden™',
    border: 'border-yellow-400/30',
    items: [
      'Cuenta regresiva de 7 días: qué hacer cada día',
      'Reducís el estrés porque sabés que estás lista',
      'Presentás la carpeta de forma profesional',
      'Tenés un plan de comunicación para el consultorio'
    ]
  }
] as const;

export const includedExtras = [
  'Plan de 7 días listo para arrancar hoy',
  'Plantillas imprimibles para la carpeta',
  'Guía de registro de observaciones',
  'Checklist para el día de la consulta'
];

export const bonuses = [
  {
    number: '01',
    title: 'Kit Consulta Lista en 24 Horas™',
    value: '$12.000',
    details: [
      'Checklist de documentos que no pueden faltar',
      'Guía de armado del bolso para el día de la consulta',
      'Separadores imprimibles para ordenar la carpeta'
    ]
  },
  {
    number: '02',
    title: 'Guion de Consulta Clara™',
    value: '$10.000',
    details: [
      'Frases listas para comunicar con claridad',
      'Cómo pedir aclaraciones sin sentir que molestás',
      'Qué decir cuando la consulta se acorta'
    ]
  },
  {
    number: '03',
    title: 'Resumen Médico Express de 1 Página™',
    value: '$11.000',
    details: [
      'Plantilla para volcar toda la información en una hoja clara',
      'El profesional entiende el caso en menos de un minuto',
      'Listo para imprimir y llevar a cualquier consulta'
    ]
  },
  {
    number: '04',
    title: 'Semáforo de Dudas y Prioridades™',
    value: '$9.000',
    details: [
      'Matriz para organizar tus preguntas según importancia',
      'Distinguís lo urgente de lo que puede esperar',
      'Nunca más salís con la duda principal sin preguntar'
    ]
  },
  {
    number: '05',
    title: 'Carpeta Digital Neurológica Ordenada™',
    value: '$10.000',
    details: [
      'Sistema de carpetas y nomenclatura de archivos',
      'Cómo escanear estudios con el celular en minutos',
      'Tenés todo a mano incluso en una guardia imprevista'
    ]
  }
] as const;
